import root from 'window-or-global';

/**
 * [executeOnNextTick]
 * Executes provided function on the next tick, for performance.
 * Uses `setTimeout` as a fallback if browser does not have a native method.
 * @param  {Function} method  The method to execute on next tick.
 */
export const executeOnNextTick = ((): Function =>
  root.requestAnimationFrame ||
  root.webkitRequestAnimationFrame ||
  root.mozRequestAnimationFrame ||
  ((callback: Function): void => {
    setTimeout(callback, 1000 / 60);
  }))();
